import * as React from 'react';
const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);

export const Avatar = (props) => (
    <div className={props.className}>
        <svg width="148" height="148" viewBox="0 0 148 148" xmlns="http://www.w3.org/2000/svg" version="1.1">
            <defs>
                <mask id="mask-circles">
                    <g fill="white">
                        <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 74 74"
                            to="360 74 74"
                            dur="20s"
                            repeatDur="indefinite"
                        />
                        <path d="M138.8 56.8L111 18.5c-4.8-6.2-12.2-9.6-20.4-8.9l-46.9 4.8c-8.2.7-15 6.2-17.7 13L7 71.2C3.6 78.7 5 87 9 93.1l27.9 38.4c4.8 6.2 12.2 9.6 20.4 8.9l46.9-4.8c8.2-.7 15-6.2 17.7-13l19-43.8c3.4-6.9 2.7-15.1-2.1-22z"/>
                    </g>
                </mask>
            </defs>
            <image xlinkHref={props.src} width="148" height="148" clipPath="url(#clip-path)"/>
        </svg>
    </div>
);